import React from "react";
import clsx from "clsx";
import { TitleModel } from "./tools/Title.model";
import { Typography } from "../Typography/Typography";
import { useIsMobile } from "../utils/useIsMobile";

import useStyles from "./Title.style";

export const Title = ({
  title,
  titleColor,
  titleFontWeight = 'normal',
  titleVariant = 'h2',
  titleComponent = 'h2',
  titleClassName,
  titleTestid,
  description,
  descriptionColor = 'greys.60',
  descriptionVariant = 'body1',
  descriptionComponent = 'p',
  descriptionClassName,
  descriptionTestid,
  align = 'left',
  className,
  disableAutoScale = false,
}: TitleModel) => {
  const c = useStyles({ align });
  const isMobile = useIsMobile();
  const effectiveTitleVariant = !disableAutoScale && titleVariant === 'h1' && isMobile ? 'h2' : titleVariant;

  return (
    <div data-testid="Title-wrapper" className={className}>
      <Typography
        variant={effectiveTitleVariant}
        component={titleComponent}
        className={clsx(c.title, titleClassName)}
        testId={titleTestid}
        textColor={titleColor}
        fontWeight={titleFontWeight}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          variant={descriptionVariant}
          component={descriptionComponent}
          className={clsx(c.description, descriptionClassName)}
          testId={descriptionTestid}
          textColor={descriptionColor}
        >
          {description}
        </Typography>
      )}
    </div>
  );
};
